<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16.923 4.702a1.147 1.147 0 01-.073-.014c-.48-.108-.85-.52-.85-1.021 0-.553.448-1.005.999-.963A13.334 13.334 0 112.704 16.999c-.042-.55.41-1 .963-1 .501 0 .913.37 1.02.85a1.147 1.147 0 01.024.15A11.333 11.333 0 1016.923 4.702z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemProgressCircleOutline'
}
</script>
